import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/pro-duotone-svg-icons/faEnvelope'
import { ComposeMessage } from '@/feature/user/messages'
import { ContentDossierSendProps, ContentDossierSendState } from '../types'
import { ToolbarButton } from '@/Components/Elements/StyledComponents/Buttons'
class ContentDossierSend extends React.PureComponent<
    ContentDossierSendProps,
    ContentDossierSendState
> {
    constructor(props: ContentDossierSendProps) {
        super(props)
        this.state = {
            compose: false,
            showSuccess: false,
        }
    }

    getComposeMessageForm() {
        return (
            <ComposeMessage
                kedo={this.props.kedo}
                dossier={this.props.dossier}
                onCloseModal={() => this.setState({ compose: false })}
            />
        )
    }

    render() {
        if (this.state.compose) {
            return this.getComposeMessageForm()
        }

        if (this.state.showSuccess) {
            return (
                <ToolbarButton
                    dense={this.props.size === 'sm'}
                    onClick={() => this.setState({ compose: true })}
                    title={this.props.kedo.t('Send message')}
                >
                    <FontAwesomeIcon icon={faEnvelope} />
                </ToolbarButton>
            )
        }

        return (
            <ToolbarButton
                dense={this.props.size === 'sm'}
                variant="outlined"
                onClick={() => this.setState({ compose: true })}
                title={this.props.kedo.t('Send message')}
            >
                <FontAwesomeIcon icon={faEnvelope} />
            </ToolbarButton>
        )
    }
}

export default ContentDossierSend
